module.exports = __webpack_public_path__ + "assets/avatar-profile.ea1e426b.svg";